import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    FormGroup,
    Typography,
    TextField,
    CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UrlConstant } from "../../commom/UrlConstant";
import Axios from "../../config/axios";
import { getUserFromLocalStorage } from "../../utils/utils";
import { useAppDispatch } from "../../Redux/hooks";
import { login } from "../../Redux/authSlice";
import { endLoading, startLoading } from "../../Redux/loadingSlice";
import Successpopup from "../common/SharedComponent/Successpopup";
import { trackEvent } from "../../config/firebase";
import { Constant } from "../../commom/Constants";

function EConsent() {
    const [isConsented, setIsConsented] = useState<Boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
    const [msg, setmsg] = useState(''); // State for controlling popup visibility
    const [Success, setSuccess] = useState(false); // State for controlling popup visibility
    const [heading, setheading] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const user = location.state ? location.state : getUserFromLocalStorage();

    React.useEffect(() => {
        if (user?.email) {
            setEmail(user.email);
        }
    }, [user]);

    React.useEffect(() => {
        if (!user || user === null) {
            navigate("/login");
        }
    }, [user, navigate]);

    const isFormValid = isConsented && email.trim() !== "";

    const acceptEConsent = async () => {
        dispatch(startLoading());
        setLoading(true);
        const payLoad = {
            user: { _id: user._id },
            email: email,
        };
        try {
            const response = await Axios.post(UrlConstant.Auth.AcceptEConsent, payLoad);

            const resData = response.data;
            const success = resData?.result;
            setheading(success ? "Success" : "Error");
            setSuccess(success);
            setShowPopup(true);
            setmsg(resData?.message);
        } catch (error: any) {
            setSuccess(false);
            setheading('Error');
            setShowPopup(true);
            setmsg("An error occurred.");
            console.log(error);
        }
        finally {
            dispatch(endLoading());
            setLoading(false);
        }
    };

    const closePopup = () => {
        setShowPopup(false);

        if (Success) {
            const updatedUser = { ...user, econsentAccepted: true, econsentAcceptedAt: new Date().toISOString() };
            if (Constant.ENV === "production") {
                trackEvent("sign_up_completed", {
                    signup_method: "email",
                    source: "econsent_accepted",
                });
            }
            dispatch(login(updatedUser));
            navigate("/dashboard", { state: updatedUser });
        }
    };

    const skipForNow = () => {
        navigate("/dashboard", { state: user });
    };

    return (
        <Container
            maxWidth={false}
            className="container_new bg-black"
            sx={{ maxWidth: "100%", margin: "0px", justifyContent: "start" }}
        >
            {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}
            {loading && (
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100vw"
                    height="100vh"
                    bgcolor="rgba(0, 0, 0, 0.5)"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                        backdropFilter: "blur(5px)",
                        zIndex: 9999,
                    }}
                >
                    <CircularProgress color="primary" />
                </Box>
            )}
            <RightSection className="RightSection">
                <Typography
                    className="Typography fw-700 mb-10 fs-24 heading"
                    width="100%"
                >
                    Electronic Records Consent
                </Typography>

                <Box
                    padding="30px"
                    overflow="auto"
                    height="60%"
                    border="2px solid #FFFFFF33"
                    borderRadius="30px"
                    sx={{
                        "&::-webkit-scrollbar": {
                            width: "5px",
                            height: "100%",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "#FFFFFF1A",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#FFFFFF80",
                            borderRadius: "6px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "#FFFFFF80",
                        },
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "20px", textAlign: "center" }}
                    >
                        <strong>Consent to Electronic Records and Communications</strong>
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        Wolfpack’s new sophisticated lending platform offers short-term point-of-sale loans for retail stock investors, eliminating credit checks and minimum deposit requirements while providing an accessible alternative to margin lending.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        Wolfpack only offers these services online, through its app available on iOS and Android and through its website  <a href="https://wolfpack.com" style={{ color: "#4A90E2" }}>wolfpack.com</a>.
                        With your consent, Wolfpack can deliver to you electronically the contracts, disclosures, and records related to your activity on the Wolfpack platform, and provide you access to these services.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        <strong>For you to access these materials electronically, you will need:</strong>
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6, paddingLeft: "20px" }}
                    >
                        • a mobile phone running iOS or Android, or a computer, with access to the internet;<br />
                        • the Wolfpack app or a browser capable of creating a secure connection;<br />
                        • sufficient storage space in your email account or on your phone or computer to save what you would like; and<br />
                        • to keep current with us your email address.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        By entering your email below, you consent to Wolfpack communicating with you about your activity on the Wolfpack platform by email to that email address.  You will need to verify your email address by clicking the verification link in the first email we will send you.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        By opening that email and clicking the verification link, you also confirm that you have access to that email account and sufficient storage to keep the emails Wolfpack will send you.  If your email address changes, be sure to log in and update it in your settings.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        By completing this form and verifying your email, you also consent to receive all the contracts, disclosures, and records related to your activity on the Wolfpack platform electronically.  You agree that your electronic signature on any of those documents has the same effect as if you were signing with ink on paper. Wolfpack will usually email you whenever you conduct certain types of activity on the platform, like taking out a loan or making a trade.  You are welcome to store a copy of the documents you receive on the Wolfpack platform by using the “save” or “print” functionality as you are viewing them. Please save or print anything that is important to you. If you ever have any trouble, just contact  <a href="mailto:support@wolfpack.com" style={{ color: "#4A90E2" }}>support@wolfpack.com</a> and we will be happy to help.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        You have the right to withdraw this consent at any time by logging in and adjusting your electronic consent in your settings.  But if you do, you will no longer be able to use the Wolfpack services, execute further trades, or take out additional loans.  Unless and until you renew your consent in your settings, your access to the app or website will be limited to viewing your past activity.  If you have any outstanding loan when you withdraw your consent, you will still owe that loan according to its terms, and Wolfpack will still be authorized to communicate with you about that loan as described in the loan agreement.  For those reasons, if you wish to withdraw your consent, we recommend you repay any loans and use the app or website to transfer your assets where you like before you close your account.
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        Your consent is completely voluntary, but we cannot process any of your applications or provide our products and services to you if you do not consent.  The decision to do business with us electronically is up to you.  If you are unwilling to receive contracts, disclosures, and records electronically, you can exit now at no cost by closing your mobile app or browser before accepting and proceeding past this consent.
                    </Typography>
                    <Typography
                        variant="body2"
                        textAlign="justify"
                        className="text-white"
                        sx={{ marginBottom: "15px", lineHeight: 1.6 }}
                    >
                        If you are ready to access the Wolfpack platform and willing to consent to electronic records, please enter your email, click Agree, and then be sure to go into your email to click the verification link.
                    </Typography>
                </Box>

                <Box my={2} width="100%">
                    <Box display="flex" alignItems="center" mb={2}>
                        <Typography
                            variant="body2"
                            sx={{ color: "white", minWidth: "120px" }} // fixed width for alignment
                        >
                            Email Address
                        </Typography>

                        <TextField
                            fullWidth
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={!!user?.email}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#FFFFFF0D",
                                    borderRadius: "15px",
                                    "& fieldset": {
                                        borderColor: "#FFFFFF33",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#FFFFFF66",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#4A90E2",
                                    },
                                },
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "white",
                                    color: "white",
                                    opacity: 1,
                                },
                                "& .MuiInputLabel-root": {
                                    color: "#FFFFFF80",
                                    "&.Mui-focused": {
                                        color: "#4A90E2",
                                    },
                                },
                            }}
                        />

                    </Box>

                    <FormGroup>
                        <FormControlLabel
                            className="custom-label"
                            required
                            control={
                                <Checkbox
                                    onChange={(e) => setIsConsented(e.target.checked)}
                                    sx={{
                                        color: "#FFFFFF80",
                                        "&.Mui-checked": {
                                            color: "#4A90E2 !important",
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography variant="body2" className="text-white" sx={{ lineHeight: 1.4 }}>
                                    By verifying my email, I consent to receive all contracts, disclosures, and records
                                    from Wolfpack electronically; consent to receive email communications about my account;
                                    and confirm that I have the hardware and software I need to access the Wolfpack platform.
                                </Typography>
                            }
                        />
                    </FormGroup>
                </Box>


                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "15px" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={!isFormValid}
                        className="btn-primary fw-700 fs-18 btn"
                        endIcon={
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15 22C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15Z"
                                    stroke="white"
                                    strokeOpacity={isFormValid ? 1 : 0.2}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7.75 12L10.58 14.83L16.25 9.17004"
                                    stroke="white"
                                    strokeOpacity={isFormValid ? 1 : 0.2}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                        sx={{
                            "&.Mui-disabled": {
                                backgroundColor: "#FFFFFF33 !important",
                                color: "#FFFFFF33 !important",
                                opacity: 0.7,
                            },
                            paddingY: "12px",
                            borderRadius: "15px",
                        }}
                        onClick={acceptEConsent}
                    >
                        I Agree & Continue
                    </Button>

                    <Button
                        variant="outlined"
                        fullWidth
                        className="btn-light fw-700 fs-18 btn"
                        sx={{
                            borderColor: "#FFFFFF33",
                            color: "#FFFFFF80",
                            paddingY: "12px",
                            borderRadius: "15px",
                        }}
                        onClick={skipForNow}
                    >
                        Skip for Now
                    </Button>
                </Box>
            </RightSection>
        </Container>
    );
}

const RightSection = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "70px 120px",
    [theme.breakpoints.down("md")]: {
        width: "100%",
    },
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.down("sm")]: {
        padding: "40px 40px",
    },
}));

export default EConsent;